/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.getElementById('Facet-Drawer');
  }
  connectedCallback() {
    this.addEventListener('click', () => {
      document.body.classList.toggle('open-cc');
      this.drawer.classList.toggle('active');
      this.drawer.removeAttribute('inert');
    });
  }
}
customElements.define('facet-toggle', FacetsToggle);

/**
 *  @class
 *  @function SidebarToggle
 */
class SidebarToggle extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const label =
      this.querySelector('.jsc-facets-all-filters-label') || this.querySelector('span');

    this.addEventListener('click', (e) => {
      e.preventDefault();
      this.drawer = document.getElementById('Sidebar-Container');
      this.drawer.classList.toggle('facets--sidebar-open');

      if (!label) {
        return;
      }
      label.textContent = this.drawer.classList.contains('facets--sidebar-open')
        ? theme.strings.hideFilters
        : theme.strings.showFilters;
    });
  }
}
customElements.define('sidebar-toggle', SidebarToggle);

/**
 * Close desktop facets sidebar (panel X button).
 */
document.addEventListener('click', (e) => {
  const closeBtn = e.target.closest('[data-facets-sidebar-close]');
  if (!closeBtn) {
    return;
  }
  e.preventDefault();
  const drawer = document.getElementById('Sidebar-Container');
  const toggle = document.getElementById('Sidebar-Toggle');
  const label =
    toggle &&
    (toggle.querySelector('.jsc-facets-all-filters-label') || toggle.querySelector('span'));
  if (!drawer) {
    return;
  }
  drawer.classList.remove('facets--sidebar-open');
  if (label && typeof theme !== 'undefined' && theme.strings && theme.strings.showFilters) {
    label.textContent = theme.strings.showFilters;
  }
});

/**
 * Jumpstart — PLP quick filters: open sidebar/drawer, expand matching facet, scroll into view.
 */
function jscUsesDesktopSidebarFilters() {
  const sidebar = document.getElementById('Sidebar-Container');
  return Boolean(
    sidebar &&
      sidebar.classList.contains('facets--sidebar') &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(min-width: 768px)').matches
  );
}

function jscOpenFacetPanelForQuickFilter() {
  if (jscUsesDesktopSidebarFilters()) {
    const drawer = document.getElementById('Sidebar-Container');
    const toggle = document.getElementById('Sidebar-Toggle');
    const span = toggle && toggle.querySelector('span');
    if (drawer && !drawer.classList.contains('facets--sidebar-open')) {
      drawer.classList.add('facets--sidebar-open');
      if (span && typeof theme !== 'undefined' && theme.strings && theme.strings.hideFilters) {
        span.textContent = theme.strings.hideFilters;
      }
    }
    return;
  }
  const facetDrawer = document.getElementById('Facet-Drawer');
  document.body.classList.add('open-cc');
  if (facetDrawer) {
    facetDrawer.classList.add('active');
    facetDrawer.removeAttribute('inert');
  }
}

function jscFocusFacetSectionByIndex(index) {
  const useDesktop = jscUsesDesktopSidebarFilters();
  const formSelector = useDesktop ? '#FacetFiltersForm' : '#FacetFiltersFormMobile';
  const form = document.querySelector(formSelector);
  if (!form) {
    return;
  }
  const targetKey = String(index);
  const rows = form.querySelectorAll('collapsible-row[data-index]');
  let targetRow = null;

  rows.forEach((row) => {
    const details = row.querySelector('details');
    if (!details) {
      return;
    }
    const isTarget = row.dataset.index === targetKey;
    if (isTarget) {
      targetRow = row;
      details.open = true;
    } else {
      details.open = false;
    }
    details.style.height = '';
    details.style.overflow = '';
  });

  if (!targetRow) {
    return;
  }
  const scrollIntoFacet = () => {
    targetRow.scrollIntoView({ block: 'start', behavior: 'smooth', inline: 'nearest' });
  };
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      setTimeout(scrollIntoFacet, useDesktop ? 220 : 160);
    });
  });
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.jsc-active-facets__type-btn');
  if (!btn || !btn.dataset.facetIndex) {
    return;
  }
  e.preventDefault();
  jscOpenFacetPanelForQuickFilter();
  jscFocusFacetSectionByIndex(btn.dataset.facetIndex);
});

/**
 *  @class
 *  @function FacetFiltersForm
 */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }
  connectedCallback() {
    this.querySelectorAll('.thb-filter-content--button').forEach((more_button) => {
      more_button.addEventListener('click', this.onMore);
    });
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.querySelectorAll('.thb-filter-count, .mobile-filter-count');
    // document.getElementById('ProductGridContainer').querySelector('.products').classList.add('loading');
    // Jumpstart: Use another selector that works for empty result
    document.getElementById('product-grid')?.classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    ScrollTrigger.batch('.animations-true .products .product-card--image-primary', {
      start: "top 90%",
      onEnter: (elements) => {
        gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
      }
    });
    document.getElementById('ProductGridContainer').querySelectorAll('.lazyload').forEach((image) => {
      lazySizes.loader.unveil(image);
    });

    // Jumpstart: re-apply facet bar toggles after AJAX replaces the product grid
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        ProductCardImageView.applyFromStorage(false);
        ProductGridViewToggle.applyFromStorage();
        const drawer = document.getElementById('Sidebar-Container');
        const toggle = document.getElementById('Sidebar-Toggle');
        const toggleSpan = toggle && toggle.querySelector('span');
        if (drawer && toggleSpan) {
          toggleSpan.textContent = drawer.classList.contains('facets--sidebar-open')
            ? theme.strings.hideFilters
            : theme.strings.showFilters;
        }
      });
    });

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);


    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      document.querySelector(selector).classList.remove('loading');
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  onMore(e) {
    let ul = this.closest('.thb-filter-content').querySelector('ul');

    if (ul.hasAttribute('filters-open')) {
      this.textContent = theme.strings.showMore;
      ul.removeAttribute('filters-open');
    } else {
      this.textContent = theme.strings.showLess;
      ul.setAttribute('filters-open', '');
    }
    e.preventDefault();
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

/**
 *  @class
 *  @function FacetRemove
 */
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);


/**
 *  @class
 *  @function FacetToolbar
 */
class FacetToolbar extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.productGrid = this.closest('#ProductGridContainer');
    this.compareToggle = this.querySelector('#compare_toggle');
    this.layoutSwitcher = this.querySelector('.facets--bar-view-as');
    this.buttons = this.querySelectorAll('.facets--bar-view-as-button');
    this.productLayout = window.localStorage.getItem('product-layout');
    if (this.layoutSwitcher) {
      this.buttons.forEach((button) => {
        button.addEventListener('click', (evt) => {
          [].forEach.call(this.buttons, function (el) {
            el.removeAttribute('disabled');
          });
          this.onLayoutChange(button, button.dataset.value);
          evt.preventDefault();
        });
      });

      if (this.productLayout && this.productLayout === 'list') {
        const toggle = this.querySelector(`.facets--bar-view-as-button-${this.productLayout}`);
        if (toggle) toggle.click();
      }
    }
    if (this.compareToggle) {
      this.compareToggle.addEventListener('change', this.onCompare);
    }
  }
  onLayoutChange(button, value) {
    button.setAttribute('disabled', '');
    this.productGrid.dataset.layout = value;
    window.localStorage.setItem('product-layout', value);
  }
  onCompare(e) {
    document.body.classList.toggle('compare-true');
    e.preventDefault();
  }
}
customElements.define('facet-toolbar', FacetToolbar);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    this.slider = this.querySelector('.price_slider');
    this.amounts = this.querySelector('.price_slider_amount');
    this.rangeLabel = this.querySelector('.price_slider_range');
    this.rangeMin = this.querySelector('.price_slider_range__min');
    this.rangeMax = this.querySelector('.price_slider_range__max');
    this.form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    this.inputEvent = new CustomEvent('input');
    this.moneyFormat = (window.theme && theme.settings && theme.settings.money_with_currency_format) || '${{amount_no_decimals}}';

    const args = {
      start: [
        parseFloat(this.slider.dataset.minValue || 0),
        parseFloat(this.slider.dataset.maxValue || this.slider.dataset.max)
      ],
      connect: true,
      step: 10,
      direction: document.dir,
      handleAttributes: [
        { 'aria-label': 'lower' },
        { 'aria-label': 'upper' },
      ],
      range: {
        'min': 0,
        'max': parseFloat(this.slider.dataset.max)
      }
    };
    noUiSlider.create(this.slider, args);

    this.slider.noUiSlider.on('update', this.onSliderUpdate.bind(this));
    this.slider.noUiSlider.on('change', this.onSliderChange.bind(this));

  }
  formatPrice(value) {
    const amount = Math.round(parseFloat(value) * 100);
    if (typeof formatMoney === 'function') {
      return formatMoney(amount, this.moneyFormat).replace(/\s+/g, '');
    }
    return String(Math.round(parseFloat(value)));
  }
  onSliderUpdate(values) {
    if (this.amounts) {
      const minInput = this.amounts.querySelector('.field__input_min');
      const maxInput = this.amounts.querySelector('.field__input_max');
      if (minInput) minInput.value = values[0];
      if (maxInput) maxInput.value = values[1];
    }
    if (this.rangeMin) this.rangeMin.textContent = this.formatPrice(values[0]);
    if (this.rangeMax) this.rangeMax.textContent = this.formatPrice(values[1]);
  }

  onSliderChange(values) {
    this.form.querySelector('form').dispatchEvent(this.inputEvent);
  }
}
customElements.define('price-slider', PriceSlider);

/* =============================================================================
 * Jumpstart — custom code (not default theme). Collection facet bar: product
 * image view (model / flatlay), grid density toggle, localStorage + listeners.
 * ============================================================================= */

/**
 * Global product-card image strip: model (2nd image) vs flatlay (1st image).
 * Respects data-no-second-img on cards (section-driven).
 */
const ProductCardImageView = {
  STORAGE_KEY: 'product-card-image-view',

  getMode() {
    const stored = window.localStorage.getItem(this.STORAGE_KEY);
    return stored === 'model' ? 'model' : 'flatlay';
  },

  updateToggleUI(mode) {
    document.querySelectorAll('.toggle-img-view').forEach((root) => {
      root.setAttribute('data-active', mode);
      const modelBtn = root.querySelector('.toggle-img-model');
      const flatBtn = root.querySelector('.toggle-img-flatlay');
      if (modelBtn) {
        modelBtn.setAttribute('aria-pressed', mode === 'model' ? 'true' : 'false');
      }
      if (flatBtn) {
        flatBtn.setAttribute('aria-pressed', mode === 'flatlay' ? 'true' : 'false');
      }
    });
  },

  applyToAllCards(mode, smooth) {
    const isModel = mode === 'model';
    const behavior = smooth ? 'smooth' : 'auto';
    document.querySelectorAll('product-card').forEach((card) => {
      const slider = card.querySelector('.product-card--image');
      const primary = card.querySelector('.product-primary-image');
      if (!slider || !primary) {
        return;
      }
      if (!card.querySelector('.product-secondary-image')) {
        return;
      }
      const noSecond = card.dataset.noSecondImg === 'true';
      const slideWidth = primary.offsetWidth;
      const targetLeft = isModel && !noSecond ? slideWidth : 0;
      slider.scrollTo({ left: targetLeft, behavior });
    });
  },

  setMode(mode, smooth) {
    const next = mode === 'model' ? 'model' : 'flatlay';
    window.localStorage.setItem(this.STORAGE_KEY, next);
    this.updateToggleUI(next);
    this.applyToAllCards(next, smooth);
  },

  applyFromStorage(smooth) {
    const mode = this.getMode();
    this.updateToggleUI(mode);
    this.applyToAllCards(mode, smooth);
  },

  init() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        ProductCardImageView.applyFromStorage(false);
      });
    });
  }
};

/** Jumpstart: grid density toggle (1st = 3 cols desktop, 2nd = 4 cols); pairs with product-grid.css */
const ProductGridViewToggle = {
  STORAGE_KEY: 'product-grid-view-toggle',

  getMode() {
    const stored = window.localStorage.getItem(this.STORAGE_KEY);
    return stored === '2nd' ? '2nd' : '1st';
  },

  updateToggleUI(mode) {
    const next = mode === '2nd' ? '2nd' : '1st';
    document.querySelectorAll('.toggle-product-grid-view').forEach((root) => {
      root.setAttribute('data-active', next);
      const firstBtn = root.querySelector('.toggle-grid-view-1st');
      const secondBtn = root.querySelector('.toggle-grid-view-2nd');
      if (firstBtn) {
        firstBtn.setAttribute('aria-pressed', next === '1st' ? 'true' : 'false');
      }
      if (secondBtn) {
        secondBtn.setAttribute('aria-pressed', next === '2nd' ? 'true' : 'false');
      }
    });
  },

  applyToGrid() {
    const mode = this.getMode();
    const grid = document.getElementById('product-grid');
    if (!grid || !grid.classList.contains('grid')) {
      return;
    }
    const isSecond = mode === '2nd';
    grid.classList.toggle('is-grid-view-1st', !isSecond);
    grid.classList.toggle('is-grid-view-2nd', isSecond);
  },

  setMode(mode) {
    const next = mode === '2nd' ? '2nd' : '1st';
    window.localStorage.setItem(this.STORAGE_KEY, next);
    this.updateToggleUI(next);
    this.applyToGrid();
  },

  applyFromStorage() {
    const mode = this.getMode();
    this.updateToggleUI(mode);
    this.applyToGrid();
  },

  init() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        ProductGridViewToggle.applyFromStorage();
      });
    });
  }
};

// Jumpstart: delegated clicks for facet bar grid + image toggles
document.addEventListener('click', (e) => {
  if (e.target.closest('.toggle-grid-view-1st')) {
    e.preventDefault();
    ProductGridViewToggle.setMode('1st');
    return;
  }
  if (e.target.closest('.toggle-grid-view-2nd')) {
    e.preventDefault();
    ProductGridViewToggle.setMode('2nd');
    return;
  }
  if (e.target.closest('.toggle-img-model')) {
    e.preventDefault();
    ProductCardImageView.setMode('model', true);
    return;
  }
  if (e.target.closest('.toggle-img-flatlay')) {
    e.preventDefault();
    ProductCardImageView.setMode('flatlay', true);
  }
});

// Jumpstart: init stored facet bar preferences on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    ProductCardImageView.init();
    ProductGridViewToggle.init();
  });
} else {
  ProductCardImageView.init();
  ProductGridViewToggle.init();
}